import { X } from 'lucide-react';
import type { Tab } from '../../lib/workspace';

interface TabBarProps {
  tabs: Tab[];
  activeTabId: string | null;
  onActivate: (tabId: string) => void;
  onClose: (tabId: string) => void;
}

export function TabBar({ tabs, activeTabId, onActivate, onClose }: TabBarProps) {
  if (tabs.length === 0) return null;

  return (
    <div className="flex items-center border-b bg-surface shrink-0 overflow-x-auto" style={{ borderColor: 'rgba(33,35,39,0.07)' }}>
      {tabs.map(tab => {
        const isActive = tab.id === activeTabId;
        return (
          <button
            key={tab.id}
            onClick={() => onActivate(tab.id)}
            className={`group flex items-center gap-1.5 px-3 py-2 text-[12px] font-medium border-b-2 -mb-px whitespace-nowrap transition-colors ${
              isActive
                ? 'border-accent text-accent bg-white'
                : 'border-transparent text-tertiary hover:text-primary hover:bg-hover'
            }`}
          >
            <span className="truncate max-w-[160px]">{tab.label}</span>
            {tab.closable && (
              <span
                onClick={e => { e.stopPropagation(); onClose(tab.id); }}
                className={`rounded-sm p-0.5 transition-colors ${
                  isActive ? 'hover:bg-accent/10 text-accent' : 'hover:bg-hover text-tertiary opacity-0 group-hover:opacity-100'
                }`}
              >
                <X size={11} />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
